var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Layer, LayerState } from "react-atmosphere-layer";
import FocusLock from "react-focus-lock";
var DefaultTransitionDuration = 0;
var DefaultBackdropStyles = {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: -1
};
function defaultRenderBackdrop(_a) {
    var state = _a.state, onClick = _a.onClick;
    return React.createElement("div", { style: DefaultBackdropStyles, onClick: onClick });
}
var DefaultContainerStyles = {
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
};
export var DialogConfigContext = React.createContext({});
export var DialogFocusLockGroupContext = React.createContext("");
var nextFocusLockGroup = 1;
export function DialogLayer(_a) {
    var render = _a.render, state = _a.state, completeTransitionExit = _a.completeTransitionExit, onBackdropClick = _a.onBackdropClick;
    var _b = React.useContext(DialogConfigContext), _c = _b.renderBackdrop, renderBackdrop = _c === void 0 ? defaultRenderBackdrop : _c, _d = _b.containerStyles, containerStyles = _d === void 0 ? DefaultContainerStyles : _d, _e = _b.transitionDuration, transitionDuration = _e === void 0 ? DefaultTransitionDuration : _e;
    var focusLockGroupRef = React.useRef();
    if (focusLockGroupRef.current === undefined) {
        focusLockGroupRef.current = "AtmosphereDialog-" + nextFocusLockGroup++;
    }
    var focusLockGroup = focusLockGroupRef.current;
    React.useEffect(function () {
        if (state === LayerState.TransitionExit) {
            if (transitionDuration === 0) {
                completeTransitionExit();
                return;
            }
            var timeout_1 = setTimeout(function () { return completeTransitionExit(); }, transitionDuration);
            return function () { return clearTimeout(timeout_1); };
        }
    }, [state]);
    return (React.createElement(FocusLock, { autoFocus: false, returnFocus: true, group: focusLockGroup },
        React.createElement(DialogFocusLockGroupContext.Provider, { value: focusLockGroup },
            React.createElement("div", { style: containerStyles },
                renderBackdrop({ state: state, onClick: onBackdropClick }),
                render({ state: state })))));
}
export default function Dialog(_a) {
    var renderProp = _a.render, onBackdropClick = _a.onBackdropClick;
    var render = React.useCallback(function (renderProps) { return (React.createElement(DialogLayer, __assign({}, renderProps, { render: renderProp, onBackdropClick: onBackdropClick }))); }, [renderProp, onBackdropClick]);
    return React.createElement(Layer, { render: render, transitionExit: true });
}
